import { useMutation } from '@apollo/client'
import { setAlertQueue } from 'cache/alerts'
import {
  ClosePendingActionRequestInput,
  DecisionActionResponse,
  SAVE_COMMENT,
} from 'queries/mutations/save-decision-comment'
import { MessageType } from 'ts/enums/messageType.enums'

export const useSaveDecision = (
  setCommentValue: (value: string) => void,
  handleClose: () => void
) => {
  const [saveComment, { loading }] = useMutation<
    DecisionActionResponse,
    ClosePendingActionRequestInput
  >(SAVE_COMMENT, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setCommentValue('')
      handleClose()
      if (data.closePendingAction.didError) {
        setAlertQueue({
          type: MessageType.ERROR,
          message: `Failed to save comment, ${data.closePendingAction.errorMessage}`,
        })
      } else {
        setAlertQueue({
          type: MessageType.SUCCESS,
          pauseAutoHideProp: true,
          message: `Decision saved Successfully`,
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onOk: () => {},
        })
      }
    },
    onError: (error: any) => {
      setAlertQueue({
        type: MessageType.ERROR,
        message: `Failed to save comment, ${error}`,
      })
    },
  })
  return { saveComment, loading }
}
